import { render, staticRenderFns } from "./PillsCompletadoPage.vue?vue&type=template&id=4daf6d84&"
import script from "./PillsCompletadoPage.vue?vue&type=script&lang=js&"
export * from "./PillsCompletadoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports